import { lazy, useContext, useEffect } from "react";
import { GridContext } from "src/context/GridContext/GridContext";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import { isMobile } from "src/components/js/statics1";
import KeikkaIcon2 from "src/components/keikka/keikkaIcon/KeikkaIcon2";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import { GridKeikkaEditorProvider, useGridKeikkaEditor } from "src/context/GridKeikkaEditorContext";
import { useSnackbar } from "src/context/SnackbarContext";
import { gridKeikka_copyJSON } from "src/pages/Grid/GridKeikka/gridKeikkaFunctions";

const GridPalkkiModal = lazy(() => import("../gridPalkkiModal/GridPalkkiModal"));
const GridKeikkaEditor = lazy(() => import("./GridKeikkaEditor"));

export default function GridKeikkaEditorModal() {
  return (
    <GridKeikkaEditorProvider>
      <GridKeikkaEditorModal2 />
    </GridKeikkaEditorProvider>
  );
}

function GridKeikkaEditorModal2() {
  const { reloadGrid, gridKeikka, gridKeikkaEditorIsOpen, setGridKeikkaEditorIsOpen } =
    useContext(GridContext) || {};
  const { setOrigKeikka, hasChanged } = useGridKeikkaEditor();
  const { openSnackbar } = useSnackbar();

  useEffect(() => {
    if (!gridKeikkaEditorIsOpen) return;
    const o = gridKeikka_copyJSON(gridKeikka);
    setOrigKeikka(o);
  }, [gridKeikkaEditorIsOpen, gridKeikka?.keikkaId]);

  const handleClose = (a) => {
    if (a === false) onCancel();
    setGridKeikkaEditorIsOpen(false);
  };

  const onSave = () => {
    // recalcPositions(keikat);
  };

  const onCancel = () => {
    if (hasChanged()) {
      openSnackbar({
        open: true,
        message: "Muutokset hylätty",
        // title: "Tilaus",
        severity: "info",
        autoHideDuration: 500,
      });
      reloadGrid();
    }
  };

  const handleMaximize = () => window.open("/tilaus/" + gridKeikka.keikkaId, "_blank");

  const rowId = gridKeikka?.keikkaId + (gridKeikka?.foreignKey ? "/" + gridKeikka.foreignKey : "");

  return (
    <LazyLoader>
      <GridPalkkiModal
        isDraggable={!isMobile()}
        open={gridKeikkaEditorIsOpen || false}
        onClose={handleClose}
        rowId={rowId}
        title={
          <>
            <KeikkaIcon2 gridKeikka={gridKeikka} size={56} />
            <Typography
              color="primary"
              variant="h6"
              align="center"
              className="fixPrint onlyWide"
              sx={{ display: "flex", gap: 1 }}>
              Tilaus
            </Typography>
          </>
        }
        onMaximize={handleMaximize}>
        <GridKeikkaEditor onSave={onSave} onCancel={onCancel} />
      </GridPalkkiModal>
    </LazyLoader>
  );
}

GridKeikkaEditorModal.propTypes = {
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
};
